import { render, staticRenderFns } from "./ProductForm.vue?vue&type=template&id=7998bed5&"
import script from "./ProductForm.vue?vue&type=script&lang=js&"
export * from "./ProductForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7998bed5')) {
      api.createRecord('7998bed5', component.options)
    } else {
      api.reload('7998bed5', component.options)
    }
    module.hot.accept("./ProductForm.vue?vue&type=template&id=7998bed5&", function () {
      api.rerender('7998bed5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/product/components/ProductForm.vue"
export default component.exports